import { render, staticRenderFns } from "./DetailImg.vue?vue&type=template&id=6adee098&scoped=true"
import script from "./DetailImg.vue?vue&type=script&lang=js"
export * from "./DetailImg.vue?vue&type=script&lang=js"
import style0 from "./DetailImg.vue?vue&type=style&index=0&id=6adee098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adee098",
  null
  
)

export default component.exports